import DataRoom from "components/global/DataRoom";

const LenderDataRoom = () => <DataRoom documentBucket="lenderDocuments" />;

export default LenderDataRoom;
